import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SubContractorsForm.css';
import leftArrowPng from '../../../../images/left-arrow.png';
import { Col, Row } from 'react-bootstrap';
import Input from '../../../shared/input/Input';

class SubContractorsForm extends Component {
  static propTypes = {
    data: PropTypes.shape({
      subContractorName: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      phoneNumber: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      streetAddress: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      unitNumberFloor: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      city: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      state: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      zipCode: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      contactFirstName: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      contactLastName: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
      email: PropTypes.shape({
        value: PropTypes.string,
        valid: PropTypes.bool,
      }),
    }),
    validationError: PropTypes.string,
    onCancel: PropTypes.func,
    onFormChange: PropTypes.func,
    onFormSubmit: PropTypes.func,
  };

  isValid() {
    return Object.keys(this.props.data)
      .map((key) => {
        return this.props.data[key].valid;
      })
      .reduce((lastValue, currentValue) => {
        return lastValue && currentValue;
      }, false);
  }

  handleBackArrow = () => {
    this.props.onCancel();
  };

  handleCancel = () => {
    this.props.onCancel();
  };

  handleChange = (attribute, value) => {
    this.props.onFormChange(attribute, value);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.onFormSubmit();
  };

  render() {
    return (
      <div className="sub-contractors-form">
        <div className="image-container">
          <img
            src={leftArrowPng}
            alt={'left-arrow'}
            onClick={this.handleBackArrow}
          />
        </div>

        <div>Add Subcontractor</div>

        <form onSubmit={this.handleSubmit}>
          <Row>
            <Col md={6}>
              <Input
                placeholder="Sub-Contractor Name"
                valid={this.props.data.subContractorName.valid}
                value={this.props.data.subContractorName.value}
                onChange={(value) =>
                  this.handleChange('subContractorName', value)
                }
              />
            </Col>

            <Col md={6}>
              <Input
                placeholder="Phone Number"
                valid={this.props.data.phoneNumber.valid}
                value={this.props.data.phoneNumber.value}
                onChange={(value) => this.handleChange('phoneNumber', value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input
                placeholder="Street Address"
                valid={this.props.data.streetAddress.valid}
                value={this.props.data.streetAddress.value}
                onChange={(value) => this.handleChange('streetAddress', value)}
              />
            </Col>

            <Col md={6}>
              <Input
                placeholder="Unit number / Floor"
                valid={this.props.data.unitNumberFloor.valid}
                value={this.props.data.unitNumberFloor.value}
                onChange={(value) =>
                  this.handleChange('unitNumberFloor', value)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input
                placeholder="City"
                valid={this.props.data.city.valid}
                value={this.props.data.city.value}
                onChange={(value) => this.handleChange('city', value)}
              />
            </Col>

            <Col md={6}>
              <Row>
                <Col md={8}>
                  <Input
                    className="state-input"
                    placeholder="State"
                    valid={this.props.data.state.valid}
                    value={this.props.data.state.value}
                    onChange={(value) => this.handleChange('state', value)}
                  />
                </Col>
                <Col md={4}>
                  <Input
                    placeholder="Zip Code"
                    valid={this.props.data.zipCode.valid}
                    value={this.props.data.zipCode.value}
                    onChange={(value) => this.handleChange('zipCode', value)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Row>
                <Col md={6}>
                  <Input
                    placeholder="Contact First Name"
                    valid={this.props.data.contactFirstName.valid}
                    value={this.props.data.contactFirstName.value}
                    onChange={(value) =>
                      this.handleChange('contactFirstName', value)
                    }
                  />
                </Col>
                <Col md={6}>
                  <Input
                    placeholder="Contact Last Name"
                    valid={this.props.data.contactLastName.valid}
                    value={this.props.data.contactLastName.value}
                    onChange={(value) =>
                      this.handleChange('contactLastName', value)
                    }
                  />
                </Col>
              </Row>
            </Col>

            <Col md={6}>
              <Input
                placeholder="Email"
                valid={this.props.data.email.valid}
                value={this.props.data.email.value}
                onChange={(value) => this.handleChange('email', value)}
              />
            </Col>
          </Row>

          {!this.isValid() ? (
            <div className="invalid-message">{this.props.validationError}</div>
          ) : null}

          <div className="button-container">
            <input
              className="btn button button-orange"
              value="Submit Request"
              type="submit"
            />
            <input
              className="btn button button-white"
              value="Cancel"
              type="button"
              onClick={this.handleCancel}
            />
          </div>
        </form>
      </div>
    );
  }
}

export default SubContractorsForm;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/SubContractorsForm.js